/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import { Inject, Injectable, Optional } from '@angular/core';
import {
  GrpcCallType,
  GrpcClient,
  GrpcClientFactory,
  GrpcEvent,
  GrpcMetadata
} from '@ngx-grpc/common';
import {
  GRPC_CLIENT_FACTORY,
  GrpcHandler,
  takeMessages,
  throwStatusErrors
} from '@ngx-grpc/core';
import { Observable } from 'rxjs';
import * as thisProto from './entertainment.pb';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleType001 from '../../../external/mercury/v1/shared/google/type/decimal.pb';
import * as booking_platformV1Shared002 from '../../../external/mercury/v1/shared/geolocation.pb';
import * as booking_platformV1Shared003 from '../../../external/mercury/v1/shared/auto-complete-result-item.pb';
import * as booking_platformV1Shared004 from '../../../external/mercury/v1/shared/seat.pb';
import * as booking_platformV1Entertainment005 from '../../../external/mercury/v1/entertainment/entertainment.pb';
import { GRPC_ENTERTAINMENT_CLIENT_SETTINGS } from './entertainment.pbconf';
/**
 * Service client implementation for ten.grpc.entertainments_service.api.Entertainment
 */
@Injectable({ providedIn: 'any' })
export class EntertainmentClient {
  private client: GrpcClient<any>;

  /**
   * Raw RPC implementation for each service client method.
   * The raw methods provide more control on the incoming data and events. E.g. they can be useful to read status `OK` metadata.
   * Attention: these methods do not throw errors when non-zero status codes are received.
   */
  $raw = {
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/Autocomplete
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.AutoCompleteResponse>>
     */
    autocomplete: (
      requestData: booking_platformV1Entertainment005.AutocompleteRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.AutoCompleteResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.entertainments_service.api.Entertainment/Autocomplete',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.AutocompleteRequest,
        responseClass: booking_platformV1Entertainment005.AutoCompleteResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/Search
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.SearchResponse>>
     */
    search: (
      requestData: booking_platformV1Entertainment005.SearchRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.SearchResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.entertainments_service.api.Entertainment/Search',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.SearchRequest,
        responseClass: booking_platformV1Entertainment005.SearchResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/VenueInfo
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.VenueInfoResponse>>
     */
    venueInfo: (
      requestData: booking_platformV1Entertainment005.VenueInfoRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.VenueInfoResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.entertainments_service.api.Entertainment/VenueInfo',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.VenueInfoRequest,
        responseClass: booking_platformV1Entertainment005.VenueInfoResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/EventInfo
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.EventInfoResponse>>
     */
    eventInfo: (
      requestData: booking_platformV1Entertainment005.EventInfoRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.EventInfoResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.entertainments_service.api.Entertainment/EventInfo',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.EventInfoRequest,
        responseClass: booking_platformV1Entertainment005.EventInfoResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/SearchPagination
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.SearchPaginationResponse>>
     */
    searchPagination: (
      requestData: booking_platformV1Entertainment005.SearchPaginationRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.SearchPaginationResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/ten.grpc.entertainments_service.api.Entertainment/SearchPagination',
        requestData,
        requestMetadata,
        requestClass:
          booking_platformV1Entertainment005.SearchPaginationRequest,
        responseClass:
          booking_platformV1Entertainment005.SearchPaginationResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/GetPerformances
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.GetPerformancesResponse>>
     */
    getPerformances: (
      requestData: booking_platformV1Entertainment005.GetPerformancesRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.GetPerformancesResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/ten.grpc.entertainments_service.api.Entertainment/GetPerformances',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.GetPerformancesRequest,
        responseClass:
          booking_platformV1Entertainment005.GetPerformancesResponse
      });
    },
    /**
     * Server streaming: /ten.grpc.entertainments_service.api.Entertainment/GetPerformanceAvailabilities
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.GetPerformanceAvailabilitiesResponse>>
     */
    getPerformanceAvailabilities: (
      requestData: booking_platformV1Entertainment005.GetPerformanceAvailabilitiesRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<
        booking_platformV1Entertainment005.GetPerformanceAvailabilitiesResponse
      >
    > => {
      return this.handler.handle({
        type: GrpcCallType.serverStream,
        client: this.client,
        path:
          '/ten.grpc.entertainments_service.api.Entertainment/GetPerformanceAvailabilities',
        requestData,
        requestMetadata,
        requestClass:
          booking_platformV1Entertainment005.GetPerformanceAvailabilitiesRequest,
        responseClass:
          booking_platformV1Entertainment005.GetPerformanceAvailabilitiesResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/PerformerInfo
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.PerformerInfoResponse>>
     */
    performerInfo: (
      requestData: booking_platformV1Entertainment005.PerformerInfoRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.PerformerInfoResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/ten.grpc.entertainments_service.api.Entertainment/PerformerInfo',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.PerformerInfoRequest,
        responseClass: booking_platformV1Entertainment005.PerformerInfoResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/EventDetails
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.EventDetailsResponse>>
     */
    eventDetails: (
      requestData: booking_platformV1Entertainment005.EventDetailsRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.EventDetailsResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path: '/ten.grpc.entertainments_service.api.Entertainment/EventDetails',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.EventDetailsRequest,
        responseClass: booking_platformV1Entertainment005.EventDetailsResponse
      });
    },
    /**
     * Unary call: /ten.grpc.entertainments_service.api.Entertainment/SearchTenEvents
     *
     * @param requestMessage Request message
     * @param requestMetadata Request metadata
     * @returns Observable<GrpcEvent<booking_platformV1Entertainment005.SearchEventsResponse>>
     */
    searchTenEvents: (
      requestData: booking_platformV1Entertainment005.SearchEventsRequest,
      requestMetadata = new GrpcMetadata()
    ): Observable<
      GrpcEvent<booking_platformV1Entertainment005.SearchEventsResponse>
    > => {
      return this.handler.handle({
        type: GrpcCallType.unary,
        client: this.client,
        path:
          '/ten.grpc.entertainments_service.api.Entertainment/SearchTenEvents',
        requestData,
        requestMetadata,
        requestClass: booking_platformV1Entertainment005.SearchEventsRequest,
        responseClass: booking_platformV1Entertainment005.SearchEventsResponse
      });
    }
  };

  constructor(
    @Optional() @Inject(GRPC_ENTERTAINMENT_CLIENT_SETTINGS) settings: any,
    @Inject(GRPC_CLIENT_FACTORY) clientFactory: GrpcClientFactory<any>,
    private handler: GrpcHandler
  ) {
    this.client = clientFactory.createClient(
      'ten.grpc.entertainments_service.api.Entertainment',
      settings
    );
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/Autocomplete
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.AutoCompleteResponse>
   */
  autocomplete(
    requestData: booking_platformV1Entertainment005.AutocompleteRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.AutoCompleteResponse> {
    return this.$raw
      .autocomplete(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/Search
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.SearchResponse>
   */
  search(
    requestData: booking_platformV1Entertainment005.SearchRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.SearchResponse> {
    return this.$raw
      .search(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/VenueInfo
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.VenueInfoResponse>
   */
  venueInfo(
    requestData: booking_platformV1Entertainment005.VenueInfoRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.VenueInfoResponse> {
    return this.$raw
      .venueInfo(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/EventInfo
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.EventInfoResponse>
   */
  eventInfo(
    requestData: booking_platformV1Entertainment005.EventInfoRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.EventInfoResponse> {
    return this.$raw
      .eventInfo(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/SearchPagination
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.SearchPaginationResponse>
   */
  searchPagination(
    requestData: booking_platformV1Entertainment005.SearchPaginationRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.SearchPaginationResponse> {
    return this.$raw
      .searchPagination(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/GetPerformances
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.GetPerformancesResponse>
   */
  getPerformances(
    requestData: booking_platformV1Entertainment005.GetPerformancesRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.GetPerformancesResponse> {
    return this.$raw
      .getPerformances(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Server streaming @/ten.grpc.entertainments_service.api.Entertainment/GetPerformanceAvailabilities
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.GetPerformanceAvailabilitiesResponse>
   */
  getPerformanceAvailabilities(
    requestData: booking_platformV1Entertainment005.GetPerformanceAvailabilitiesRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<
    booking_platformV1Entertainment005.GetPerformanceAvailabilitiesResponse
  > {
    return this.$raw
      .getPerformanceAvailabilities(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/PerformerInfo
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.PerformerInfoResponse>
   */
  performerInfo(
    requestData: booking_platformV1Entertainment005.PerformerInfoRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.PerformerInfoResponse> {
    return this.$raw
      .performerInfo(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/EventDetails
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.EventDetailsResponse>
   */
  eventDetails(
    requestData: booking_platformV1Entertainment005.EventDetailsRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.EventDetailsResponse> {
    return this.$raw
      .eventDetails(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }

  /**
   * Unary call @/ten.grpc.entertainments_service.api.Entertainment/SearchTenEvents
   *
   * @param requestMessage Request message
   * @param requestMetadata Request metadata
   * @returns Observable<booking_platformV1Entertainment005.SearchEventsResponse>
   */
  searchTenEvents(
    requestData: booking_platformV1Entertainment005.SearchEventsRequest,
    requestMetadata = new GrpcMetadata()
  ): Observable<booking_platformV1Entertainment005.SearchEventsResponse> {
    return this.$raw
      .searchTenEvents(requestData, requestMetadata)
      .pipe(throwStatusErrors(), takeMessages());
  }
}
